export const environment = {
    production: true,
    kartor: {
        LMTopoWebb: 'https://portalproxy.skogsstyrelsen.se/topowebb/wms/v1',
        arsskador: 'assets/img/kriging',
        arsskadorKarta: {
            url: 'https://geodpags.skogsstyrelsen.se/arcgis/rest/services/Geodataportal/GeodataportalVisaAbinrapportheatmap_4_0/MapServer',
            sublayers: {
                land: {
                    id: 0
                },
                landsdel: {
                    id: 1
                },
                lan: {
                    id: 2
                },
                afo: {
                    id: 3
                },
                stratum: {
                    id: 4
                },

                fjallnaraGransYta: {
                    id: 5
                },
                sverigeMaskYta: {
                    id: 6
                },
                heatmap: {
                    id: 7
                }
            }
        },
        geodataportalVisaAbinrapport_3_0: {
            url: 'https://geodpags.skogsstyrelsen.se/arcgis/rest/services/Geodataportal/GeodataportalVisaAbinrapport/MapServer',
            sublayers: {
                sjoar: {
                    parentId: 0,
                    id: 1
                },
                fjallnaraGransYta: {
                    parentId: 2
                },

                arsskadorTallAfo: {
                    parentId: 3,
                    id: 4
                },
                arsskadorTallLan: {
                    parentId: 3,
                    id: 5
                },
                arsskadorTallLandsdel: {
                    parentId: 3,
                    id: 6
                },

                oskadadTallAfo: {
                    parentId: 7,
                    id: 8
                },
                oskadadTallLan: {
                    parentId: 7,
                    id: 9
                },
                oskadadTallLandsdel: {
                    parentId: 7,
                    id: 10
                },

                arsskadorGranAfo: {
                    parentId: 11,
                    id: 12
                },
                arsskadorGranLan: {
                    parentId: 11,
                    id: 13
                },
                arsskadorGranLandsdel: {
                    parentId: 11,
                    id: 14
                },

                konkurrensstatusRASEAfo: {
                    parentId: 15,
                    id: 16
                },
                konkurrensstatusRASELan: {
                    parentId: 15,
                    id: 17
                },
                konkurrensstatusRASELandsdel: {
                    parentId: 15,
                    id: 18
                },

                tallMagraMarkerAfo: {
                    parentId: 19,
                    id: 20
                },
                tallMagraMarkerLan: {
                    parentId: 19,
                    id: 21
                },
                tallMagraMarkerLandsdel: {
                    parentId: 19,
                    id: 22
                },

                tallMellanmarkerAfo: {
                    parentId: 23,
                    id: 24
                },
                tallMellanmarkerLan: {
                    parentId: 23,
                    id: 25
                },
                tallMellanmarkerLandsdel: {
                    parentId: 23,
                    id: 26
                }
            }
        },
        lmTopowebbSkikt: {
            url: 'https://portalproxy.skogsstyrelsen.se/topowebb-skikt/wms/v1.1',
            layers: {
                terrangskuggning: 'terrangskuggning',
                mark: 'mark',
                hydrografi_ytor: 'hydrografi_ytor',
                hydrografi: 'hydrografi',
                kurvor: 'kurvor',
                kommunikation: 'kommunikation',
                jarnvag: 'jarnvag',
                fjallinformation: 'fjallinformation',
                bebyggelse: 'bebyggelse',
                anlaggningar: 'anlaggningar',
                kraftledningar: 'kraftledningar',
                administrativ_indelning: 'administrativ_indelning',
                bestammelser: 'bestammelser',
                adresser: 'adresser',
                text: 'text',
                mark_nedtonad: 'mark_nedtonad',
                hydrografi_ytor_nedtonad: 'hydrografi_ytor_nedtonad',
                hydrografi_nedtonad: 'hydrografi_nedtonad',
                kurvor_nedtonad: 'kurvor_nedtonad',
                kommunikation_nedtonad: 'kommunikation_nedtonad',
                jarnvag_nedtonad: 'jarnvag_nedtonad',
                fjallinformation_nedtonad: 'fjallinformation_nedtonad',
                bebyggelse_nedtonad: 'bebyggelse_nedtonad',
                anlaggningar_nedtonad: 'anlaggningar_nedtonad',
                kraftledningar_nedtonad: 'kraftledningar_nedtonad',
                administrativ_indelning_nedtonad: 'administrativ_indelning_nedtonad',
                bestammelser_nedtonad: 'bestammelser_nedtonad',
                adresser_nedtonad: 'adresser_nedtonad',
                text_nedtonad: 'text_nedtonad'
            }
        }
    },
    skogsstyrelsenUrl: 'https://www.skogsstyrelsen.se/',
    oauth2: {
        authority: 'https://auth.skogsstyrelsen.se/connect/token',
        clientId: 'sks_skobi_rapport',
        clientSecret: '64d45f51-5087-890c-4307-26ca529ff406',
        scope: 'sks_api',
        grantType: 'client_credentials'
    },
    googleCharts: {
        scriptSource: 'https://www.gstatic.com/charts/loader.js'
    }
};
